"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M9.88,15.15H14.6V11.21h-.79v-.79a1.57,1.57,0,1,0-3.15,0v.79H9.88ZM12,12.79a.26.26,0,1,1,.39.23v.69a.13.13,0,1,1-.26,0V13A.26.26,0,0,1,12,12.79Zm-1-2.36a1.31,1.31,0,0,1,2.62,0v.79H10.93Z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M6.77,11.65a.45.45,0,0,0,.3-.42V9c0-.44,0-.9,1.79-.9h8.5v2.24a.45.45,0,0,0,.78.3l4.48-4.92a.45.45,0,0,0,0-.6L18.14.19a.45.45,0,0,0-.78.3V2.73H8.85c-2.78,0-4,2.47-4,4.92a6.68,6.68,0,0,0,1.45,3.87.45.45,0,0,0,.34.16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M18.2,12.48a.45.45,0,0,0-.79.29V15c0,.44,0,.9-1.79.9H7.12V13.66a.45.45,0,0,0-.78-.3L1.86,18.29a.45.45,0,0,0,0,.6l4.48,4.92a.45.45,0,0,0,.78-.3V21.27h8.5c2.78,0,4-2.47,4-4.92A6.67,6.67,0,0,0,18.2,12.48Z"
  }))));
};

exports["default"] = _default;